"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkGroupIds = exports.CheckSubTasksGuard = void 0;
const is_sub_task_in_active_state_path_1 = require("../../utils/is-sub-task-in-active-state-path");
// common guard functionality
function CheckSubTasksGuard(task, params) {
    // ignore check for optional subTasks
    // only check subTasks that are associated with the current task.status
    // unless their statePath is not set (default behavior)
    const subTasks = (task.children || []).filter(child => {
        return !child.isOptional && is_sub_task_in_active_state_path_1.isSubTaskInActiveStatePath(child, task);
    });
    if (subTasks.length === 0) {
        console.warn('[check-subtasks] No task.children found.');
        return false;
    }
    const loop = (params === null || params === void 0 ? void 0 : params.partial) ? 'some' : 'every';
    const result = subTasks[loop](subTask => subTask.status === (params === null || params === void 0 ? void 0 : params.path));
    console.log('[check-subtasks] all subtasks checked', result);
    return result;
}
exports.CheckSubTasksGuard = CheckSubTasksGuard;
// items should match minimum number of group ids
function checkGroupIds(options) {
    const { items, groupIds, inGroup } = options;
    // allow more items per group but not less
    if (groupIds.length > 0 && groupIds.length > items.length) {
        return false;
    }
    // check only items that are part of group
    const groups = groupIds.map(id => {
        return { id, index: 0, items: items.filter(item => inGroup(item, id)) };
    });
    // all groups should have at least 1 item
    if (groups.some(group => group.items.length === 0)) {
        return false;
    }
    // check all possible combinations to make sure
    // at least 1 unique user approves exactly from 1 group.
    // being unique per group means a user that is included in
    // multiple groups is never reused in the check
    let result;
    while (typeof result !== 'boolean') {
        // check with current index values
        const values = groups.map(group => group.items[group.index]);
        // if values are unique and match total groups, the final result is true
        if (new Set(values).size === groupIds.length) {
            result = true;
            break;
        }
        // increment index of items for the next check
        for (const [index, group] of Array.from(groups.entries())) {
            if (group.index < group.items.length - 1) {
                group.index++;
                // stop increment here and start check with current index values
                break;
            }
            // if this is the last group, check failed
            if (index >= groups.length - 1) {
                result = false;
                break;
            }
            // restart index for this group, then continue increment for next group
            group.index = 0;
        }
    }
    return result;
}
exports.checkGroupIds = checkGroupIds;
//# sourceMappingURL=CheckSubTasksPlugin.js.map